import { Box, Button, Typography } from "@mui/material";
import { ChartContainer, LineChart, LinePlot, useDrawingArea } from "@mui/x-charts";
import { CompanyStudentAgeFlags } from "../../__generated__/graphql"
import { useEffect, useState } from "react";
type AgeFlagGraphProps = {
    data: CompanyStudentAgeFlags[]
    title: string
    filter: string
    maxYValue: number
}
function mapDataToGraph(
    data: CompanyStudentAgeFlags[],
    field: string
) {
    return ages.map((age) => {
        // all sessions for this age (18+ bucket maps to 19)
        const matches = data.filter(
            (d) => d.ageAtSession === age || (age === 19 && d.ageAtSession >= 18)
        );

        // average the field across all matches
        const sum = matches.reduce((acc, curr) => {
            if (!curr.assessmentData) return acc;

            const val = curr.assessmentData[field as keyof typeof curr.assessmentData];
            return acc + (typeof val === "number" ? val : 0);
        }, 0);

        const y = matches.length > 0 ? sum / matches.length : 0;

        return { x: age, y };
    });
}
const ages = Array.from({ length: 13 }, (_, i) => i + 6);
ages.push(19);
export function AgeMarkerGraph({ data, title, filter, maxYValue }: AgeFlagGraphProps) {
    const [graphData, setGraphData] = useState<{ x: number, y: number }[]>([]);
    useEffect(() => {
        if (data && data.length > 0) {
            const mapped = mapDataToGraph(data, filter);
            setGraphData(mapped);
        } else {
            // Reset graph if no data
            setGraphData([]);
        }
    }, [data, filter])
    return (
        <Box component="div" sx={{ padding: ".5rem" }}>
            <Typography align="center">{title}</Typography>
            <LineChart
                title={title}
                height={300}
                dataset={graphData}
                series={[
                    {
                        data: graphData.map((d) => d.y), // <-- just numbers
                        type: "line",
                    }
                ]}
                xAxis={[{
                    min: 6,
                    max: 19,
                    dataKey: 'x',
                    valueFormatter: (v: number) => (v === 19 ? "18+" : v.toString()),
                    label: "Age",
                }]}
                margin={{ bottom: 0, left: 0 }}
                yAxis={[{
                    label: `Total ${filter.charAt(0).toUpperCase() + filter.slice(1)} Markers`, offset: 0,
                    min: 0, // start at 0
                    max: maxYValue,
                    tickNumber: 6,
                }]}
            />
        </Box>
    )
}